/**
 * Product Info Component
 * Handles product description toggle functionality
 */

(function() {
  if (typeof document === 'undefined') return;
  
  // 防抖函数
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }
  
  function initDescriptionToggle() {
    const toggles = document.querySelectorAll('[data-description-toggle]');
    
    toggles.forEach(function(toggle) {
      // Skip if already initialized
      if (toggle.dataset.initialized === 'true') return;
      toggle.dataset.initialized = 'true';

      const descriptionId = toggle.getAttribute('aria-controls');
      if (!descriptionId) return;
      
      const description = document.getElementById(descriptionId);
      if (!description) return;
      
      // 缓存元素引用，避免重复查询
      const showMore = toggle.querySelector('.show-more');
      const showLess = toggle.querySelector('.show-less');

      // Check if content exceeds 3 lines by comparing scrollHeight with clientHeight
      // When collapsed, scrollHeight should be greater than clientHeight if content exceeds 3 lines
      const checkHeight = function() {
        const isCollapsed = description.classList.contains('product-description--collapsed');
        if (!isCollapsed) {
          description.classList.add('product-description--collapsed');
        }
        
        const scrollHeight = description.scrollHeight;
        const clientHeight = description.clientHeight;
        
        if (!isCollapsed) {
          description.classList.remove('product-description--collapsed');
        }

        // If scrollHeight is greater than clientHeight, content exceeds 3 lines
        if (scrollHeight <= clientHeight + 5) {
          // Content fits in 3 lines, hide toggle button
          toggle.style.display = 'none';
          return false;
        }
        return true;
      };

      // 使用requestAnimationFrame优化DOM操作
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (!checkHeight()) return;

          // Add click handler (只绑定一次)
          toggle.addEventListener('click', function() {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
              description.classList.remove('product-description--expanded');
              description.classList.add('product-description--collapsed');
              toggle.setAttribute('aria-expanded', 'false');
              if (showMore) showMore.hidden = false;
              if (showLess) showLess.hidden = true;
            } else {
              description.classList.remove('product-description--collapsed');
              description.classList.add('product-description--expanded');
              toggle.setAttribute('aria-expanded', 'true');
              if (showMore) showMore.hidden = true;
              if (showLess) showLess.hidden = false;
            }
          });
        });
      });
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptionToggle);
  } else {
    initDescriptionToggle();
  }

  // Re-initialize when product info is updated (for variant changes) - 使用防抖
  const debouncedInit = debounce(initDescriptionToggle, 100);
  document.addEventListener('product:rerender', debouncedInit);
})();

/**
 * 将Size Chart block注入到variant-picker的第二个option的option-info中
 * 方案：隐藏原始Size Chart，复制一份到指定位置显示
 */
(function() {
  'use strict';
  
  // 存储原始的Size Chart blocks（用于复制）
  const originalSizeChartBlocks = [];
  // 存储已注入的Size Chart副本的引用
  const injectedSizeChartCopies = new WeakSet();
  
  // 防抖函数
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }
  
  // 初始化：隐藏原始Size Chart并保存引用
  function initializeOriginalSizeCharts() {
    // 查找所有size-chart block
    const allSizeChartBlocks = Array.from(document.querySelectorAll('[data-block-type="size-chart"]'));
    
    allSizeChartBlocks.forEach(function(sizeChartBlock) {
      // 检查是否已经处理过
      if (sizeChartBlock.dataset.sizeChartProcessed === 'true') {
        return;
      }
      
      // 标记为已处理
      sizeChartBlock.dataset.sizeChartProcessed = 'true';
      
      // 隐藏原始Size Chart
      sizeChartBlock.style.display = 'none';
      
      // 保存原始block的引用
      originalSizeChartBlocks.push(sizeChartBlock);
    });
  }
  
  // 优化后的SVG ID处理函数（合并所有步骤，减少DOM查询）
  function processSvgIds(sizeChartCopy) {
    const allSvgs = sizeChartCopy.querySelectorAll('svg');
    if (allSvgs.length === 0) return;
    
    const idMap = new Map();
    const timestamp = Date.now();
    let idCounter = 0;
    
    // 单次遍历：收集ID并更新
    allSvgs.forEach(function(svg) {
      const elementsWithId = svg.querySelectorAll('[id]');
      
      // 收集并生成新ID
      elementsWithId.forEach(function(element) {
        const originalId = element.id;
        if (originalId && !idMap.has(originalId)) {
          idMap.set(originalId, originalId + '-copy-' + timestamp + '-' + (idCounter++));
        }
      });
      
      // 立即更新ID（避免二次查询）
      elementsWithId.forEach(function(element) {
        const originalId = element.id;
        if (originalId && idMap.has(originalId)) {
          element.id = idMap.get(originalId);
        }
      });
      
      // 更新use标签引用
      const useElements = svg.querySelectorAll('use');
      useElements.forEach(function(useEl) {
        const xlinkHref = useEl.getAttribute('xlink:href');
        if (xlinkHref && xlinkHref.startsWith('#')) {
          const refId = xlinkHref.substring(1);
          if (idMap.has(refId)) {
            useEl.setAttribute('xlink:href', '#' + idMap.get(refId));
          }
        }
        const href = useEl.getAttribute('href');
        if (href && href.startsWith('#')) {
          const refId = href.substring(1);
          if (idMap.has(refId)) {
            useEl.setAttribute('href', '#' + idMap.get(refId));
          }
        }
      });
      
      // 更新url()引用（合并查询）
      const styleElements = svg.querySelectorAll('[style], [fill], [stroke]');
      const urlRegex = /url\(#([^)]+)\)/g;
      
      styleElements.forEach(function(styleEl) {
        // 处理fill属性
        const fill = styleEl.getAttribute('fill');
        if (fill && fill.startsWith('url(#')) {
          const match = fill.match(urlRegex);
          if (match) {
            const refId = match[0].match(/url\(#([^)]+)\)/)[1];
            if (idMap.has(refId)) {
              styleEl.setAttribute('fill', 'url(#' + idMap.get(refId) + ')');
            }
          }
        }
        
        // 处理stroke属性
        const stroke = styleEl.getAttribute('stroke');
        if (stroke && stroke.startsWith('url(#')) {
          const match = stroke.match(urlRegex);
          if (match) {
            const refId = match[0].match(/url\(#([^)]+)\)/)[1];
            if (idMap.has(refId)) {
              styleEl.setAttribute('stroke', 'url(#' + idMap.get(refId) + ')');
            }
          }
        }
        
        // 处理style属性
        const styleAttr = styleEl.getAttribute('style');
        if (styleAttr && styleAttr.includes('url(#')) {
          let newStyle = styleAttr;
          idMap.forEach(function(newId, oldId) {
            const escaped = oldId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            newStyle = newStyle.replace(new RegExp('url\\(#' + escaped + '\\)', 'g'), 'url(#' + newId + ')');
          });
          if (newStyle !== styleAttr) {
            styleEl.setAttribute('style', newStyle);
          }
        }
      });
    });
  }
  
  // 优化后的样式设置函数（批量处理）
  function applyStyles(sizeChartCopy) {
    // 批量设置图标容器样式
    const iconContainers = sizeChartCopy.querySelectorAll('.size-chart-icon-container');
    iconContainers.forEach(function(container) {
      container.style.cssText = 'display: inline-flex; align-self: end; text-decoration: none;';
    });
    
    // 批量设置SVG样式
    const allSvgs = sizeChartCopy.querySelectorAll('svg');
    allSvgs.forEach(function(svg) {
      if (svg.style.display === 'none') {
        svg.style.display = 'block';
      }
      if (!svg.style.width) {
        svg.style.width = 'auto';
      }
      if (!svg.style.height) {
        svg.style.height = 'auto';
      }
    });
  }
  
  // 复制并注入Size Chart到指定位置（性能优化版）
  function injectSizeChartToVariantPicker(forceReinject) {
    // 如果没有原始Size Chart，先初始化
    if (originalSizeChartBlocks.length === 0) {
      initializeOriginalSizeCharts();
    }
    
    if (originalSizeChartBlocks.length === 0) {
      return;
    }
    
    // 缓存查询结果
    const variantPickers = document.querySelectorAll('variant-picker.variant-picker');
    if (variantPickers.length === 0) return;
    
    variantPickers.forEach(function(variantPicker) {
      const variantOptions = variantPicker.querySelectorAll('.variant-picker__option');
      if (variantOptions.length < 2) return;
      
      const optionInfo = variantOptions[1].querySelector('.variant-picker__option-info');
      if (!optionInfo) return;
      
      // 快速检查是否需要注入
      const existingCopy = optionInfo.querySelector('[data-size-chart-copy="true"]');
      
      // 如果副本存在且仍然有效（在 DOM 中且仍在正确位置），则跳过重新注入
      // 这样可以避免在 variant 变化时不停更新 Size Chart
      if (existingCopy && document.body.contains(existingCopy) && optionInfo.contains(existingCopy)) {
        return;
      }
      
      // 移除旧副本（只有在需要时才移除）
      if (existingCopy) {
        existingCopy.remove();
      }
      
      // 使用DocumentFragment批量操作（如果多个Size Chart）
      const fragment = document.createDocumentFragment();
      
      originalSizeChartBlocks.forEach(function(originalBlock) {
        if (!document.body.contains(originalBlock)) return;
        
        // 克隆
        const sizeChartCopy = originalBlock.cloneNode(true);
        sizeChartCopy.setAttribute('data-size-chart-copy', 'true');
        sizeChartCopy.style.display = '';
        
        // 清理样式注释
        if (sizeChartCopy.style.cssText) {
          sizeChartCopy.style.cssText = sizeChartCopy.style.cssText.replace(/\/\*.*position:\s*absolute.*\*\//gi, '');
        }
        
        // 处理SVG ID（优化后的单次遍历）
        processSvgIds(sizeChartCopy);
        
        // 应用样式（批量处理）
        applyStyles(sizeChartCopy);
        
        // 处理modal ID
        const modal = sizeChartCopy.querySelector('x-modal');
        if (modal && modal.id) {
          const originalModalId = modal.id;
          const newModalId = originalModalId + '-copy-' + Date.now();
          modal.id = newModalId;
          
          // 批量更新按钮引用
          const buttons = sizeChartCopy.querySelectorAll('[aria-controls="' + originalModalId + '"]');
          buttons.forEach(function(button) {
            button.setAttribute('aria-controls', newModalId);
          });
        }
        
        injectedSizeChartCopies.add(sizeChartCopy);
        fragment.appendChild(sizeChartCopy);
      });
      
      // 一次性添加到DOM
      optionInfo.appendChild(fragment);
    });
  }
  
  // 页面加载完成后执行
  function initSizeChartInjection() {
    // 使用requestAnimationFrame优化初始化时机
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        // 先初始化原始Size Chart（隐藏它们）
        initializeOriginalSizeCharts();
        // 然后注入副本
        injectSizeChartToVariantPicker(true);
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChartInjection);
  } else {
    initSizeChartInjection();
  }
  
  // 检查 Size Chart 副本是否仍然有效（缓存查询结果）
  let cachedVariantPickers = null;
  function getVariantPickers() {
    if (!cachedVariantPickers) {
      cachedVariantPickers = document.querySelectorAll('variant-picker.variant-picker');
    }
    return cachedVariantPickers;
  }
  
  function isSizeChartCopyValid() {
    const variantPickers = getVariantPickers();
    for (let i = 0; i < variantPickers.length; i++) {
      const variantOptions = variantPickers[i].querySelectorAll('.variant-picker__option');
      if (variantOptions.length < 2) continue;
      
      const optionInfo = variantOptions[1].querySelector('.variant-picker__option-info');
      if (!optionInfo) continue;
      
      const existingCopy = optionInfo.querySelector('[data-size-chart-copy="true"]');
      // 如果副本存在且仍然在 DOM 中，说明不需要重新注入
      if (existingCopy && document.body.contains(existingCopy)) {
        return true;
      }
    }
    return false;
  }
  
  // 防抖的重新注入函数
  const debouncedReinject = debounce(function() {
    // 重新初始化原始Size Chart（以防有新的）
    initializeOriginalSizeCharts();
    
    // 只在 Size Chart 副本不存在或无效时才重新注入
    // 这样可以避免在 variant 变化时不停更新
    if (!isSizeChartCopyValid()) {
      injectSizeChartToVariantPicker(true);
    }
  }, 200);
  
  // 监听产品信息更新事件（变体变化时）
  document.addEventListener('product:rerender', debouncedReinject);
  
  // 监听variant-picker的变化（使用MutationObserver，优化性能）
  function observeVariantPicker() {
    const variantPickers = getVariantPickers();
    
    variantPickers.forEach(function(variantPicker) {
      if (variantPicker.dataset.observed === 'true') return;
      variantPicker.dataset.observed = 'true';
      
      // 使用防抖优化MutationObserver回调
      const debouncedCallback = debounce(function() {
        // 只在 Size Chart 副本不存在或无效时才重新注入
        if (!isSizeChartCopyValid()) {
          injectSizeChartToVariantPicker(true);
        }
      }, 100);
      
      const observer = new MutationObserver(function(mutations) {
        // 快速检查：只关注移除操作和option-info的变化
        let shouldReinject = false;
        
        for (let i = 0; i < mutations.length && !shouldReinject; i++) {
          const mutation = mutations[i];
          
          // 检查移除的节点
          if (mutation.removedNodes.length > 0) {
            for (let j = 0; j < mutation.removedNodes.length && !shouldReinject; j++) {
              const node = mutation.removedNodes[j];
              if (node.nodeType === 1) {
                if (node.getAttribute && node.getAttribute('data-size-chart-copy') === 'true') {
                  shouldReinject = true;
                  break;
                }
                if (node.querySelector && node.querySelector('[data-size-chart-copy="true"]')) {
                  shouldReinject = true;
                  break;
                }
              }
            }
          }
          
          // 检查option-info的变化
          if (!shouldReinject && mutation.target && mutation.target.classList) {
            if (mutation.target.classList.contains('variant-picker__option-info')) {
              if (!mutation.target.querySelector('[data-size-chart-copy="true"]')) {
                shouldReinject = true;
              }
            }
          }
        }
        
        if (shouldReinject) {
          debouncedCallback();
        }
      });
      
      // 优化：只观察必要的变化类型
      observer.observe(variantPicker, {
        childList: true,
        subtree: true
        // 移除characterData，减少触发频率
      });
    });
  }
  
  // 延迟观察，确保variant-picker已渲染
  requestAnimationFrame(function() {
    setTimeout(observeVariantPicker, 300);
  });
  
  // 页面加载后也执行一次监听设置
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(observeVariantPicker, 500);
    });
  }
  
  // 清除缓存的variant pickers（当DOM更新时）
  document.addEventListener('product:rerender', function() {
    cachedVariantPickers = null;
  });
})();

/**
 * 修复variant picker中input的checked状态同步问题
 * 确保在切换选项时，checked="checked"属性正确更新
 */
(function() {
  'use strict';
  
  // 缓存DOM查询结果
  let cachedVariantPickers = null;
  let cachedProductData = null;
  
  function getVariantPickers() {
    if (!cachedVariantPickers) {
      cachedVariantPickers = document.querySelectorAll('variant-picker.variant-picker');
    }
    return cachedVariantPickers;
  }
  
  function getProductData() {
    if (!cachedProductData) {
      const productScript = document.querySelector('script[data-product-json]');
      if (productScript) {
        try {
          cachedProductData = JSON.parse(productScript.textContent);
        } catch (e) {
          console.warn('Failed to parse product data:', e);
          cachedProductData = window.productData || {};
        }
      } else {
        cachedProductData = window.productData || {};
      }
    }
    return cachedProductData;
  }
  
  // 防抖函数
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }
  
  // 从label中提取文本值
  function getLabelText(label) {
    if (!label) return '';
    
    // 方法1: 尝试从可见的span中获取文本（排除sr-only）
    const visibleSpans = label.querySelectorAll('span:not(.sr-only)');
    if (visibleSpans.length > 0) {
      const text = visibleSpans[0].textContent.trim();
      if (text) return text;
    }
    
    // 方法2: 尝试从sr-only的span中获取文本
    const srOnlySpan = label.querySelector('span.sr-only');
    if (srOnlySpan) {
      const text = srOnlySpan.textContent.trim();
      if (text) return text;
    }
    
    // 方法3: 直接获取label的文本内容
    let text = label.textContent.trim();
    // 清理文本，移除多余的空白字符
    text = text.replace(/\s+/g, ' ').trim();
    return text;
  }
  
  // 更新选中值的显示文本
  function updateSelectedValueDisplay() {
    const variantPickers = getVariantPickers();
    
    variantPickers.forEach(function(variantPicker) {
      const variantOptions = variantPicker.querySelectorAll('.variant-picker__option');
      
      variantOptions.forEach(function(option) {
        // 找到当前option中选中的input
        const checkedInput = option.querySelector('input[data-option-position]:checked');
        
        if (!checkedInput) return;
        
        // 找到对应的label元素
        let label = null;
        const inputLabel = checkedInput.closest('label');
        if (inputLabel) {
          label = inputLabel;
        } else if (checkedInput.id) {
          label = document.querySelector('label[for="' + checkedInput.id + '"]');
        }
        
        if (!label) return;
        
        // 从label中提取文本值
        const selectedText = getLabelText(label);
        if (!selectedText) return;
        
        // 找到需要更新的显示元素
        // 优先查找 class 为 variant-picker__option-selected-value 的元素
        let displayElement = option.querySelector('.variant-picker__option-selected-value');
        
        // 如果没有找到，查找 variant-picker__option-info 中的 span（在 legend 后面的）
        if (!displayElement) {
          const optionInfo = option.querySelector('.variant-picker__option-info');
          if (optionInfo) {
            const hStack = optionInfo.querySelector('.h-stack');
            if (hStack) {
              // 查找 legend 后面的 span
              const legend = hStack.querySelector('legend');
              if (legend && legend.nextElementSibling && legend.nextElementSibling.tagName === 'SPAN') {
                displayElement = legend.nextElementSibling;
              } else {
                // 如果没有找到，查找 h-stack 中的第二个子元素（span）
                const spans = hStack.querySelectorAll('span');
                if (spans.length > 0) {
                  displayElement = spans[0];
                }
              }
            }
          }
        }
        
        // 更新显示文本
        if (displayElement) {
          displayElement.textContent = selectedText;
        }
      });
    });
  }
  
  // 同步variant picker中所有input的checked状态
  function syncCheckedStates() {
    const variantPickers = getVariantPickers();
    
    variantPickers.forEach(function(variantPicker) {
      const formId = variantPicker.getAttribute('form-id');
      if (!formId) return;
      
      const form = document.forms[formId];
      if (!form) return;
      
      // 获取当前表单中所有选中的input
      const checkedInputs = Array.from(form.elements).filter(function(element) {
        return element.matches('input[data-option-position]:checked');
      });
      
      // 对于每个variant option，确保只有一个input是checked
      const optionPositions = new Set();
      checkedInputs.forEach(function(input) {
        const position = input.getAttribute('data-option-position');
        if (position) {
          optionPositions.add(position);
        }
      });
      
      // 确保每个option position只有一个checked的input
      optionPositions.forEach(function(position) {
        const inputsInPosition = Array.from(form.elements).filter(function(element) {
          return element.matches('input[data-option-position="' + position + '"]');
        });
        
        // 找到应该被选中的input（根据checkedInputs）
        const shouldBeChecked = checkedInputs.find(function(input) {
          return input.getAttribute('data-option-position') === position;
        });
        
        // 更新所有input的checked状态
        inputsInPosition.forEach(function(input) {
          if (shouldBeChecked && input === shouldBeChecked) {
            input.checked = true;
            input.setAttribute('checked', 'checked');
          } else {
            input.checked = false;
            input.removeAttribute('checked');
          }
        });
      });
    });
    
    // 同步checked状态后，更新显示文本
    updateSelectedValueDisplay();
  }
  
  // 更新库存信息和同步variant ID
  function updateInventoryDisplay() {
    // 查找所有variant-picker，确保variant ID正确同步
    const variantPickers = document.querySelectorAll('variant-picker');
    
    variantPickers.forEach(function(variantPicker) {
      const formId = variantPicker.getAttribute('form-id');
      if (!formId) return;
      
      const form = document.forms[formId];
      if (!form) return;
      
      // 从variant-picker的script[data-variant]获取当前variant数据
      const variantScript = variantPicker.querySelector('script[data-variant]');
      if (!variantScript) return;
      
      try {
        const variantData = JSON.parse(variantScript.textContent);
        if (!variantData || !variantData.id) return;
        
        // 获取表单中的variant input
        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) return;
        
        // 确保variant ID同步
        const currentVariantId = variantInput.value;
        const newVariantId = variantData.id.toString();
        
        if (currentVariantId !== newVariantId) {
          // 更新variant input的值
          variantInput.value = newVariantId;
          // 触发change事件，让其他组件（如库存、价格等）更新
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (e) {
        // 忽略解析错误
        console.warn('Failed to parse variant data:', e);
      }
    });
  }
  
  // 检查选项是否是颜色选项
  function isColorOption(optionElement) {
    if (!optionElement) return false;
    
    const legend = optionElement.querySelector('legend');
    if (!legend) return false;
    
    const optionName = legend.textContent.trim().toLowerCase();
    const colorLabels = ['color', 'colour', 'couleur', 'farbe', 'colore', '颜色', '顏色'];
    
    return colorLabels.some(function(label) {
      return optionName.includes(label);
    });
  }
  
  // 检查选项是否是size选项
  function isSizeOption(optionElement) {
    if (!optionElement) return false;
    
    const legend = optionElement.querySelector('legend');
    if (!legend) return false;
    
    const optionName = legend.textContent.trim().toLowerCase();
    const sizeLabels = ['size', 'taille', 'größe', 'taglia', '尺寸', '尺碼'];
    
    return sizeLabels.some(function(label) {
      return optionName.includes(label);
    });
  }
  
  // 检查size选项在当前已选属性组合下是否可用
  // selectedOptionsByPosition: { [position]: value } 除size外的所有已选属性，如 { 1: "WIDE", 2: "RED" }
  function checkSizeAvailability(sizeValue, sizePosition, selectedOptionsByPosition, productData) {
    if (!productData || !productData.variants) return true;
    
    for (let i = 0; i < productData.variants.length; i++) {
      const variant = productData.variants[i];
      if (!variant.options) continue;
      
      // 检查所有非size的已选属性是否匹配
      let allOptionsMatch = true;
      for (const pos in selectedOptionsByPosition) {
        const position = parseInt(pos, 10);
        if (position === sizePosition) continue;
        
        const variantOptionValue = variant.options[position - 1];
        if (!variantOptionValue) {
          allOptionsMatch = false;
          break;
        }
        
        const normalizedVariant = String(variantOptionValue).trim().toLowerCase();
        const normalizedSelected = String(selectedOptionsByPosition[pos]).trim().toLowerCase();
        
        if (normalizedVariant !== normalizedSelected) {
          allOptionsMatch = false;
          break;
        }
      }
      
      if (!allOptionsMatch) continue;
      
      // 检查size是否匹配（使用宽松匹配）
      const variantSizeValue = variant.options[sizePosition - 1];
      if (!variantSizeValue) continue;
      
      const normalizedVariantSize = String(variantSizeValue).trim().toLowerCase();
      const normalizedSizeValue = String(sizeValue).trim().toLowerCase();
      
      if (normalizedVariantSize === normalizedSizeValue) {
        return variant.available === true;
      }
      
      const variantSizeWithoutPrefix = normalizedVariantSize.replace(/^(eur|us|uk|cm)\s*/i, '').trim();
      const sizeValueWithoutPrefix = normalizedSizeValue.replace(/^(eur|us|uk|cm)\s*/i, '').trim();
      
      if (variantSizeWithoutPrefix === sizeValueWithoutPrefix) {
        return variant.available === true;
      }
    }
    
    return false;
  }
  
  // 获取指定option的已选值（从variant script或checked input的label）
  function getSelectedOptionValue(optionElement, position, variantPicker) {
    const variantScript = variantPicker.querySelector('script[data-variant]');
    if (variantScript) {
      try {
        const variantData = JSON.parse(variantScript.textContent);
        if (variantData && variantData.options && variantData.options.length >= position) {
          return variantData.options[position - 1];
        }
      } catch (e) {}
    }
    
    const checkedInput = optionElement.querySelector('input[data-option-position="' + position + '"]:checked');
    if (checkedInput) {
      const label = checkedInput.closest('label, a');
      if (label) {
        const text = label.textContent.trim().split('\n')[0].trim();
        if (text) return text;
      }
    }
    return null;
  }
  
  // 同步所有选项维度（尺码、颜色、宽度等）的 is-disabled 样式
  function syncAllOptionStyles(form, variantPicker) {
    if (!form || !variantPicker) return;

    // Prefer product data embedded directly in the variant-picker (works for quick buy too).
    // Fall back to the global script[data-product-json] on the page.
    var productData = null;
    var localScript = variantPicker.querySelector('script[data-picker-product-json]');
    if (localScript) {
      try { productData = JSON.parse(localScript.textContent); } catch(e) {}
    }
    if (!productData || !productData.variants) {
      productData = getProductData();
    }
    if (!productData || !productData.variants) return;

    // Guard: if the cached global product data belongs to a different product, skip.
    const pickerHandle = variantPicker.getAttribute('handle');
    if (!localScript && pickerHandle && productData.handle && pickerHandle !== productData.handle) {
      return;
    }

    const options = variantPicker.querySelectorAll('.variant-picker__option');

    // 第一步：收集每个 position 的当前选中值
    const selectedOptionsByPosition = {};
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const firstInput = option.querySelector('input[data-option-position]');
      if (!firstInput) continue;
      const position = parseInt(firstInput.getAttribute('data-option-position'));
      const value = getSelectedOptionValue(option, position, variantPicker);
      if (value) selectedOptionsByPosition[position] = value;
    }

    // 第二步：对每个选项的每个值，判断是否有货
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const firstInput = option.querySelector('input[data-option-position]');
      if (!firstInput) continue;
      const position = parseInt(firstInput.getAttribute('data-option-position'));

      // 构造"除本选项外"的已选组合
      const otherSelected = {};
      for (const pos in selectedOptionsByPosition) {
        if (parseInt(pos) !== position) otherSelected[pos] = selectedOptionsByPosition[pos];
      }

      // 找到该选项下所有 input
      const inputs = Array.from(form.elements).filter(function(el) {
        return el.matches('input[data-option-position="' + position + '"]');
      });

      inputs.forEach(function(input) {
        // 找到对应 label（兄弟节点 或 for 属性）
        var label = null;
        if (input.id) label = document.querySelector('label[for="' + input.id + '"]');
        if (!label) {
          var next = input.nextElementSibling;
          if (next && next.matches('label, a')) label = next;
        }
        if (!label) return;

        // 获取选项值文本（兼容 sr-only、block-swatch span、普通 span）
        var valueText = null;
        var srOnly = label.querySelector('.sr-only');
        if (srOnly) {
          valueText = srOnly.textContent.trim();
        } else {
          var span = label.querySelector('span:not(.block-swatch__color)');
          valueText = span ? span.textContent.trim() : label.textContent.trim();
        }
        valueText = valueText ? valueText.replace(/\s+/g, ' ').trim() : null;
        if (!valueText) return;

        var isAvailable;
        if (input.disabled || input.hasAttribute('hidden')) {
          isAvailable = false;
        } else {
          isAvailable = checkSizeAvailability(valueText, position, otherSelected, productData);
        }

        if (isAvailable) {
          label.classList.remove('is-disabled');
        } else {
          label.classList.add('is-disabled');
        }
      });
    }
  }

  // 保留旧函数名作为别名，避免改动其他调用点
  function syncSizeOptionStyles(form, variantPicker) { syncAllOptionStyles(form, variantPicker); }
  function syncColorOptionStyles(form, variantPicker) { syncAllOptionStyles(form, variantPicker); }

  // 防抖的variant变化处理函数
  const debouncedHandleVariantChange = debounce(function() {
    syncCheckedStates();
    updateSelectedValueDisplay();
    updateInventoryDisplay();
    
    // 同步更新选项的样式
    const variantPickers = document.querySelectorAll('variant-picker');
    variantPickers.forEach(function(variantPicker) {
      const formId = variantPicker.getAttribute('form-id');
      if (!formId) return;
      
      const form = document.forms[formId];
      if (form) {
        syncSizeOptionStyles(form, variantPicker);
        syncColorOptionStyles(form, variantPicker);
      }
    });
  }, 100);
  
  // 监听variant变化事件，确保checked状态正确
  function handleVariantChange() {
    // 使用requestAnimationFrame优化DOM操作
    requestAnimationFrame(function() {
      debouncedHandleVariantChange();
    });
  }
  
  // 监听variant-picker的script[data-variant]变化，确保及时更新
  function observeVariantScript() {
    const variantPickers = document.querySelectorAll('variant-picker');
    
    variantPickers.forEach(function(variantPicker) {
      if (variantPicker.dataset.variantObserved === 'true') return;
      variantPicker.dataset.variantObserved = 'true';
      
      const variantScript = variantPicker.querySelector('script[data-variant]');
      if (!variantScript) return;
      
      // 使用防抖优化MutationObserver回调
      const debouncedUpdate = debounce(function() {
        updateSelectedValueDisplay();
        updateInventoryDisplay();
        
        // 同步更新选项的样式
        const formId = variantPicker.getAttribute('form-id');
        if (formId) {
          const form = document.forms[formId];
          if (form) {
            syncSizeOptionStyles(form, variantPicker);
            syncColorOptionStyles(form, variantPicker);
          }
        }
      }, 50);
      
      const observer = new MutationObserver(function() {
        // 当variant script内容变化时，更新显示
        debouncedUpdate();
      });
      
      observer.observe(variantScript, {
        characterData: true,
        childList: true,
        subtree: true
      });
    });
  }
  
  // 监听product:rerender事件 - 清除缓存并更新
  document.addEventListener('product:rerender', function(event) {
    // 清除缓存
    cachedVariantPickers = null;
    cachedProductData = null;
    
    // 等下一帧执行，确保 DOM 已更新
    requestAnimationFrame(function() {
      handleVariantChange();
      // 重新观察variant script的变化
      observeVariantScript();
      
      // 确保选项的样式正确更新
      const variantPickers = document.querySelectorAll('variant-picker');
      variantPickers.forEach(function(variantPicker) {
        const formId = variantPicker.getAttribute('form-id');
        if (!formId) return;
        
        const form = document.forms[formId];
        if (form) {
          syncSizeOptionStyles(form, variantPicker);
          syncColorOptionStyles(form, variantPicker);
        }
      });
    });
  });
  
  // 初始化时也观察variant script
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(observeVariantScript, 200);
    });
  } else {
    setTimeout(observeVariantScript, 200);
  }
  
  // 监听variant:change事件
  document.addEventListener('variant:change', handleVariantChange);
  
  // 防抖的颜色选项变化处理
  const debouncedColorChange = debounce(function(form, variantPicker) {
    syncSizeOptionStyles(form, variantPicker);
    syncColorOptionStyles(form, variantPicker);
  }, 50);
  
  // 监听input的change事件，确保checked状态正确
  document.addEventListener('change', function(event) {
    if (event.target.matches && event.target.matches('input[data-option-position]')) {
      const input = event.target;
      const formId = input.getAttribute('form');
      if (!formId) return;
      
      const form = document.forms[formId];
      if (!form) return;
      
      const position = input.getAttribute('data-option-position');
      if (!position) return;
      
      // 如果是radio类型，确保同一组中只有一个checked
      if (input.type === 'radio' && input.checked) {
        const sameGroupInputs = Array.from(form.elements).filter(function(element) {
          return element.matches('input[data-option-position="' + position + '"]') && element !== input;
        });
        
        sameGroupInputs.forEach(function(otherInput) {
          otherInput.checked = false;
          otherInput.removeAttribute('checked');
        });
        
        // 确保当前input有checked属性
        input.setAttribute('checked', 'checked');
        
        // 任意选项变化时更新size按钮样式（包括Width、Color等，因为会影响size可用性）
        const variantPicker = input.closest('variant-picker') || form.querySelector('variant-picker') || document.querySelector('variant-picker[form-id="' + formId + '"]');
        if (variantPicker) {
          syncSizeOptionStyles(form, variantPicker);
          syncColorOptionStyles(form, variantPicker);
          debouncedColorChange(form, variantPicker);
        }
        
        // 更新显示文本 - 使用requestAnimationFrame优化
        requestAnimationFrame(function() {
          updateSelectedValueDisplay();
        });
      }
    }
  }, true); // 使用捕获阶段，确保在其他处理程序之前执行
  
  // 监听label的点击事件，确保点击后立即同步checked状态
  document.addEventListener('click', function(event) {
    // 查找点击的label元素
    let label = event.target.closest('label');
    if (!label) return;
    
    // 检查label是否关联了variant picker的input
    const forAttr = label.getAttribute('for');
    let input = null;
    if (forAttr) {
      input = document.getElementById(forAttr);
    } else {
      input = label.querySelector('input[data-option-position]');
    }
    
    // 如果label没有关联variant picker的input，跳过
    if (!input || !input.matches('input[data-option-position]')) return;
    
    const formId = input.getAttribute('form');
    if (!formId) return;
    
    const form = document.forms[formId];
    if (!form) return;
    
    const position = input.getAttribute('data-option-position');
    if (!position) return;
    
    // 使用requestAnimationFrame优化DOM操作
    requestAnimationFrame(function() {
      // 如果是radio类型，确保同一组中只有一个checked
      if (input.type === 'radio') {
        const sameGroupInputs = Array.from(form.elements).filter(function(element) {
          return element.matches('input[data-option-position="' + position + '"]');
        });
        
        sameGroupInputs.forEach(function(otherInput) {
          if (otherInput.checked) {
            otherInput.setAttribute('checked', 'checked');
          } else {
            otherInput.removeAttribute('checked');
          }
        });
        
        // 更新显示文本
        updateSelectedValueDisplay();
      }
    });
  }, true); // 使用捕获阶段
  
  // 页面加载时也执行一次
  function initCheckedStateSync() {
    requestAnimationFrame(function() {
      setTimeout(function() {
        syncCheckedStates();
        updateSelectedValueDisplay();
        
        // 同步更新选项的样式
        const variantPickers = document.querySelectorAll('variant-picker');
        variantPickers.forEach(function(variantPicker) {
          const formId = variantPicker.getAttribute('form-id');
          if (!formId) return;
          
          const form = document.forms[formId];
          if (form) {
            syncSizeOptionStyles(form, variantPicker);
            syncColorOptionStyles(form, variantPicker);
          }
        });
      }, 200);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckedStateSync);
  } else {
    initCheckedStateSync();
  }
})();

/**
 * Fullscreen loading overlay for SKU/variant switching
 */
(function() {
  'use strict';

  var overlay = null;
  var hideTimer = null;

  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'variant-loading-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = '<div class="variant-loading-spinner"></div>';
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function showLoading() {
    clearTimeout(hideTimer);
    var el = getOverlay();
    el.classList.add('is-visible');
  }

  function hideLoading() {
    var el = getOverlay();
    // Small delay so the overlay doesn't flicker on cached variants
    hideTimer = setTimeout(function() {
      el.classList.remove('is-visible');
    }, 80);
  }

  function init() {
    // Show overlay when user changes a variant option
    document.addEventListener('change', function(e) {
      var input = e.target;
      if (input && input.matches('variant-picker input[data-option-position], variant-picker input[name*="option"]')) {
        showLoading();

        // product:rerender fires on the form element (no bubbles), so listen there directly
        var variantPicker = input.closest('variant-picker');
        var formId = variantPicker && variantPicker.getAttribute('form-id');
        var form = formId ? document.forms[formId] : null;
        if (form && !form._variantRerenderBound) {
          form._variantRerenderBound = true;
          form.addEventListener('product:rerender', function() {
            hideLoading();
          });
        }

        // Safety fallback: hide after 3s in case rerender event is missed
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function() {
          getOverlay().classList.remove('is-visible');
        }, 3000);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
